import React from 'react';
import Seo from '../../components/Seo';

function Cookies() {
  return (
    <div className="page page--narrow">
      <Seo title="Política de cookies" />
      <h1>Política de cookies</h1>
      <p>
        Esta web no registra ninguna visita hasta que aceptas el banner de cookies. Si aceptas, guardamos de forma
        anónima la página que visitas, de dónde vienes y el tipo de dispositivo — nunca tu IP en claro, ni la
        compartimos con Google Analytics ni con ningún tercero: es analítica propia, solo para saber qué contenido
        interesa más. Puedes cambiar tu decisión en cualquier momento borrando los datos de este sitio en los
        ajustes de tu navegador.
      </p>
    </div>
  );
}

export default Cookies;
